import React, { useState } from "react";
import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import { CustLife_detail, PostQuoteLife } from "../../Redux/actions/NumLife";
import { Button, Form, DatePicker, Select, Input, Row, Col } from "antd/lib";
import moment from "moment";
import { CalendarOutlined } from "@ant-design/icons";
import IncomeData from "../Number LifePage/IncomeData";

export default function EditDetailLife({ setIsModalOpenMember }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const CusDeatail = useSelector((state) => state?.lifedetail?.cusInfo);
  const QuotePost = useSelector((state) => state?.lifedetail?.QuickQuotePost);
  const [dob, setDob] = useState("");
  const [Age, setAge] = useState(
    CusDeatail?.Age ? CusDeatail?.Age + "Years" : ""
  );
  const [AgeInNum, setAgeInNum] = useState(
    CusDeatail?.Age ? CusDeatail?.Age : ""
  );

  const [loading, setLoading] = useState(false);
  console.log("CusDeatail", CusDeatail);
  const calculateAge = (date) => {
    console.log(date);
    const dateString = moment(date).format("YYYY-MM-DD");
    console.log(dateString);

    setDob(dateString);
    const dobObject = new Date(date);
    console.log(dobObject);
    const ageDifMs = Date.now() - dobObject.getTime();
    console.log(ageDifMs);

    const ageDate = new Date(ageDifMs);
    console.log(ageDate);

    const ageInYears = Math.abs(ageDate.getUTCFullYear() - 1970).toString();
    console.log(ageInYears);
    if (ageInYears === "53") {
      setAge("");
      setAgeInNum("");
    } else {
      setAge(ageInYears + " " + "years");
      setAgeInNum(ageInYears);
    }
    console.log(Age);
  };

  const disabledDate = (current) => {
    const today = moment();
    const minDate = today.subtract(18, "years");

    return current.isAfter(minDate, "day");
  };
  const getDefaultPickerValue = () => {
    const today = moment();
    const minDate = today.subtract(18, "years");
    return minDate;
  };

  const validatePolicyTerm = (_, value) => {
    const age = parseInt(CusDeatail?.Age);
    if (age >= 56) {
      return Promise.reject(
        new Error(`Plan Premium not defined for this Plan, Age :${age}.`)
      );
    }
    return Promise.resolve();
  };
  const onFinish = (values) => {
    console.log("product values", values);
    const UpdateCus = {
      ...CusDeatail,
      Name: values?.name,
      Mobile: values?.phonenumber,
      Age: AgeInNum,
      Email: values?.email,
      Gender: values?.gender,
      IsSmoker: values?.isSmoker,
      dateofbirth: moment(values?.dateofbirth).format("YYYY-MM-DD"),
      Occupation: values?.occupation,
      Education: values?.education,
      Income: values?.income,
      PolicyTerm: values?.policyTerm,
      PremiumTerm:
        values?.policyTerm === "10"
          ? "6"
          : values?.policyTerm === "12"
          ? "6"
          : "8",
    };
    // console.log("UpdateCusssssssss", UpdateCus);
    const UpdatePlan = {
      ...QuotePost,
      Age: AgeInNum,
      Gender: values?.gender,
      IsSmoker: values?.isSmoker,
      PolicyTerm: values?.policyTerm,
      PremiumTerm:
        values?.policyTerm === "10"
          ? "6"
          : values?.policyTerm === "12"
          ? "6"
          : "8",
      TranDate: moment(new Date()).format("YYYY-MM-DD"),
    };
    console.log("UpdatePlannnnn", UpdatePlan);
    setLoading(true);
    setTimeout(() => {
      dispatch(PostQuoteLife(UpdatePlan));
      dispatch(CustLife_detail(UpdateCus));
      setLoading(false);
      setIsModalOpenMember(false);
    }, 500);
  };
  return (
    <>
      <Form
        layout="vertical"
        form={form}
        requiredMark={false}
        onFinish={onFinish}
      >
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  pattern: /^[A-Za-z\s]+$/,
                  message: "Invalid Name, only letters are allowed",
                },
                {
                  required: true,
                  message: "please input name",
                },
              ]}
              initialValue={CusDeatail?.Name}
            >
              <Input placeholder="Enter Name (eg. Harry)" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Mobile Number"
              name="phonenumber"
              rules={[
                {
                  pattern: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
                  message: "Invalid Mobile No",
                },
                { required: true, message: "Enter Mobile No" },
              ]}
              initialValue={CusDeatail?.Mobile}
            >
              <Input maxLength={10} placeholder="Mobile NUmber" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "Please Input Email",
                },
              ]}
              initialValue={CusDeatail?.Email}
            >
              <Input
                autoComplete="off"
                style={{ width: "100%" }}
                placeholder="Email"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="gender"
              label="Gender"
              rules={[
                {
                  required: true,
                  message: "Please Select Gender",
                },
              ]}
              initialValue={CusDeatail?.gender}
            >
              <Select
                // onChange={handleChange}
                style={{ textAlign: "left" }}
                placeholder="Select Gender"
                options={[
                  {
                    value: "M",
                    label: "Male",
                  },
                  {
                    value: "F",
                    label: "Female",
                  },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Tobacco Habit"
              name="isSmoker"
              rules={[
                {
                  required: true,
                  message: "Please Select",
                },
              ]}
              initialValue={CusDeatail?.IsSmoker}
            >
              <Select
                // onChange={handleChange}
                style={{ textAlign: "left" }}
                placeholder="Smoking Habit"
                options={[
                  {
                    value: "Y",
                    label: "Smoker",
                  },
                  {
                    value: "N",
                    label: "Non Smoker",
                  },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              // {...formItemLayout}
              label="Date of Birth"
              name="dateofbirth"
              rules={[
                {
                  required: true,
                  message: "please input DOB",
                },
              ]}
              initialValue={
                CusDeatail?.dateofbirth ? moment(CusDeatail?.dateofbirth) : null
              }
            >
              <DatePicker
                disabledDate={disabledDate}
                defaultPickerValue={getDefaultPickerValue()}
                style={{ width: "100%", padding: "10px" }}
                suffixIcon={
                  Age ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ marginRight: "4px", color: "#0000ff94" }}>
                        {Age}
                      </span>
                      <CalendarOutlined />
                    </div>
                  ) : (
                    <CalendarOutlined />
                  )
                }
                format="YYYY-MM-DD"
                placeholder="YYYY-MM-DD"
                onChange={(date) => calculateAge(date)}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="occupation"
              label="Occupation"
              rules={[
                {
                  required: true,
                  message: "please select Occupation",
                },
              ]}
              initialValue={CusDeatail?.Occupation}
            >
              <Select
                // onChange={handleChange}
                style={{ textAlign: "left" }}
                placeholder="Occupation"
                options={[
                  {
                    value: "Salaried",
                    label: "Salaried",
                  },
                  {
                    value: "Self Employed",
                    label: "Self Employed",
                  },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="education"
              label="Education"
              rules={[
                {
                  required: true,
                  message: "please select Education",
                },
              ]}
              initialValue={CusDeatail?.Education}
            >
              <Select
                style={{ textAlign: "left" }}
                placeholder="Education"
                options={[
                  {
                    value: "Post Graduate",
                    label: "Post Graduate",
                  },
                  {
                    value: "Graduate",
                    label: "Graduate",
                  },
                  {
                    value: "12th Pass",
                    label: "12th Pass",
                  },
                  {
                    value: "10th Pass",
                    label: "10th Pass",
                  },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="income"
              label="Annual Income"
              rules={[
                {
                  required: true,
                  message: "please select Income",
                },
              ]}
              initialValue={CusDeatail?.Income}
            >
              <Select
                style={{ textAlign: "left" }}
                placeholder="Annual Income"
                options={IncomeData?.map((p) => ({
                  value: p?.value,
                  label: p?.label,
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="policyTerm"
              label="Policy Term"
              rules={[
                {
                  required: true,
                  message: "please select Income",
                },
                {
                  validator: validatePolicyTerm,
                },
              ]}
              initialValue={CusDeatail?.PolicyTerm}
            >
              <Select
                style={{ textAlign: "left" }}
                placeholder="Policy Term"
                options={[
                  {
                    value: "10",
                    label: "10 Years",
                  },
                  {
                    value: "12",
                    label: "12 Years",
                  },
                  {
                    value: "15",
                    label: "15 Years",
                  },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item>
              <div className="step-btn-health">
                <Button
                  loading={loading}
                  style={{ width: "100%" }}
                  type="primary"
                  htmlType="submit"
                >
                  Update
                </Button>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}
